<template>
  <div
    id="app"
    class="app-container"
  >
    <app-header />
    <main>
      <!-- force component re-render when API request finishes -->
      <!-- can't rely on route change as a task might route back to same task with new data -->
      <router-view :key="$store.getters['processStep/lastUpdated']" />
      <session-expiration
        :button-label="$t('sessionExpiration.button')"
        :description="$t('sessionExpiration.description')"
        :title="$t('sessionExpiration.title')"
      />
      <back-navigation-modal
        :description="$t('backButtonModal.description')"
        :positive-button-text="$t('backButtonModal.positiveButtonText')"
        :allow-routing-to-first-page="false"
      />
    </main>
    <app-footer />
  </div>
</template>

<script>
  import AppHeader from './components/AppHeader.vue';
  import AppFooter from './components/AppFooter.vue';
  import { SessionExpiration, BackNavigationModal } from '@bigbank/web-loco';
  import { mapActions } from 'vuex';

  export default {
    components: {
      AppFooter,
      AppHeader,
      SessionExpiration,
      BackNavigationModal,
    },

    async created() {
      await this.initializeSsoSession();
      await this.appStarted();
      await this.initializeHeartbeat();
    },
    methods: {
      ...mapActions('processStep', ['appStarted']),
      ...mapActions('auth', [
        'initializeSsoSession',
        'initializeHeartbeat',
      ]),
    },
  };
</script>

<style lang="scss">
  main {
    flex-grow: 1;
  }
  .app-container {
    min-height: 100vh;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    display: flex;
    flex-direction: column;
  }
</style>
